<nav class="navbar navbar-expand-lg bg-body-tertiary fixed-top">
  <div class="container-fluid">
     <img src="assets/img/blockcurrLogo.png" style="width:90px;height:50px;top:5px" alt="logo" class="logo" />
  
    <a class="navbar-brand" href="#" style="word-spacing: -8px;">Blocurrscan</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
       <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <!-- <li class="nav-item">
          <a class="nav-link active" aria-current="page"   routerLink="/dashboard">Transaction</a>
        </li> -->
        <!-- <li class="nav-item">
          <a class="nav-link" routerLink="/transactionDetails">Transaction</a>
        </li> -->
        <!-- <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            Dropdown
          </a>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" href="#">Action</a></li>
            <li><a class="dropdown-item" href="#">Another action</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" href="#">Something else here</a></li>
          </ul>
        </li>
        <li class="nav-item">
          <a class="nav-link disabled" aria-disabled="true">Disabled</a>
        </li> -->
      </ul> 
      <form class="d-flex me-3" role="search" >
        <input  (focus)="searchInput.value = ''"  #searchInput class="form-control me-2 searchTxtField" type="search" placeholder="Search by Txn Hash" aria-label="Search"  />
        <button class="btn btn-outline-success" (click)="onSearchValue(searchInput.value)" style="width:75px">Search</button>
      </form>
    </div>
  </div>
</nav>

<app-loader></app-loader>
  <router-outlet />

  <footer class="footer mt-auto py-3">
    <div class="container" style="margin-right: 350px">
      <span  style="color: #000" >Copyright 2026 Blockcurr Exchange. All Rights Reserved.</span>
    </div>
  </footer>


